module.exports = __webpack_public_path__ + "static/moulin-logo.66dcaa51.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sponsors/moulin-logo.png
// module id = 142
// module chunks = 83392758035670 211492426229339